import { GetNetSuiteExpenseCategories } from 'shared/data/webApp/v1';

import { CategoryWithSubName } from './CategoryCell.types';

export const mapCategories = (
    categories: GetNetSuiteExpenseCategories['response']['values']
): CategoryWithSubName[] => {
    return categories.map((category) => ({
        ...category,
        subName: '',
        text: category.name,
        rates: (category.rates || []).map((rate) => ({
            ...rate,
            currency: rate.currencyInternalId,
        })),
    }));
};
